module.exports = __webpack_public_path__ + "img/workPerformance.3d64f781.svg";